import { unescapeXml } from '@/lib/utils';
import { Node } from '@tiptap/core';

export const UnsupportedNodeHeadless = Node.create({
    name: 'unsupported',

    atom: true,

    group: 'block',

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => element.getAttribute('id'),
                renderHTML: attributes => {
                    if (attributes.id) {
                        return { id: attributes.id };
                    }
                    return {};
                },
            },
            html: {
                default: '',
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'unsupported',
                getAttrs: element => {
                    // Store the inner HTML as an attribute
                    const html = element instanceof HTMLElement ? element.innerHTML : '';
                    return { html: unescapeXml(html) };
                },
            },
        ];
    },

    renderHTML({ node, HTMLAttributes }) {
        return [
            'unsupported',
            { ...HTMLAttributes, class: 'unsupported-box' },
            ['div', { class: 'unsupported-label' }, '⚠️ Unsupported Content'],
            ['div', { class: 'unsupported-content' }, node.attrs.html],
        ];
    },
});

export const UnsupportedNode = UnsupportedNodeHeadless.extend({
    addNodeView() {
        return ({ node }) => {
            const dom = document.createElement('div');
            dom.className = 'border border-gray-400 bg-gray-50 rounded p-4 my-2';

            const label = document.createElement('div');
            label.className = 'unsupported-label text-red-700 font-bold mb-2 flex items-center gap-2';
            label.textContent = '⚠️ This resource is not supported yet';

            const content = document.createElement('div');
            content.className = 'unsupported-content max-h-32 overflow-y-auto text-sm text-gray-700 bg-white rounded p-2';
            content.innerText = node.attrs.html;

            dom.appendChild(label);
            dom.appendChild(content);

            return {
                dom,
            };
        };
    },
});

export default UnsupportedNode;
